import PropTypes from "prop-types";

export const skillType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(["general", "specific"]),
});

export const skillsType = PropTypes.arrayOf(skillType);
